<div class="loading-bar-container">
  <ng-container *ngIf="isLoadingState$ | async">
    <div class="loading-bar-left"></div>
    <div class="loading-bar-right"></div>
    <div class="loading-bar-blue"></div>
  </ng-container>

  <div
    [attr.data-qa]="
      (isLoadingState$ | async) ? 'isLoadingState' : 'notLoadingState'
    "
  ></div>
</div>
